import { Component, OnInit } from '@angular/core';
import { PopupService } from '../shared/popup.service';

@Component({
  selector: 'app-global-popup',
  templateUrl: './global-popup.component.html',
styleUrls: ['./global-popup.component.scss'],
})
export class GlobalPopupComponent implements OnInit {

  record: any = null;

  constructor(private popupService: PopupService) {}

  ngOnInit() {
    this.popupService.popupData$.subscribe(res => {
      this.record = res;
    });
  }

  close() {
    this.popupService.closePopup();
  }
}
